// cafeArtists — which café chairs a city artist is sitting in right now
// (2026-10-31, components/CafeGuests writes it once a second from the city's
// own timeline): { bySeat: Map(chair name → { a, name, seat, table }) }.
// CafeCounter reads it so an artist's chair is never offered to you.
// Plain module state, like interiorFloor: nothing re-renders for it.
export const cafeArtists = { bySeat: new Map() };
